/**
 * Created by ganlu on 27/12/2016.
 */
import angular from 'angular';
import fancyboxService from './fancybox-plus.service';
import fancyboxableDirective from './fancyboxable.directive';
import fancyboxDirective from './fancybox.directive';

import 'fancybox-plus/dist/jquery.fancybox-plus';
import 'fancybox-plus/css/jquery.fancybox-plus.css';

import './fancybox-plus.scss';

let fancyboxModule = angular.module('fancyboxPlus', [])
    .service('fancyboxService', fancyboxService)
    .directive('fancyboxable', fancyboxableDirective)
    .directive('fancybox', fancyboxDirective)
    .name;

export default fancyboxModule;



// WEBPACK FOOTER //
// ./src/app/modules/fancybox-plus/fancybox-plus.js